import { Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';

export const programId = '6138e2547fcbf60affd2cc4b';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    useFingerprinting: true,
    marketConsent: {
        enabled: true,
    },
};
